import Module from '@/models/list/Module';
import Unit from '@/models/list/Unit';

import APIService from '@/services/APIService';

const NAMESPACE = 'course-modules';

export default {
  index(params) {
    return APIService.get(NAMESPACE, { params, rOptions: { model: Module, many: true } });
  },
  show(id, params) {
    return APIService.get(`${NAMESPACE}/${id}`, { params, rOptions: { model: Module } });
  },
  create(data, obs) {
    return APIService.post(NAMESPACE, data, { rOptions: { obs } });
  },
  update(id, data) {
    return APIService.put(`${NAMESPACE}/${id}`, data);
  },
  delete(id) {
    return APIService.delete(`${NAMESPACE}/${id}`);
  },
  /** Клонирование модуля */
  clone(id, data) {
    return APIService.post(`${NAMESPACE}/${id}/clone`, data);
  },
  /** Подписка организации на модуль */
  request(id, data) {
    return APIService.post(`${NAMESPACE}/${id}/request`, data);
  },
  /** Отписка организации на модуль */
  getRequests(data) {
    return APIService.get(`${NAMESPACE}/requests`, data);
  },
  reject(id, data) {
    return APIService.post(`${NAMESPACE}/requests/${id}/reject`, data);
  },
  /** Сортировка тем и уроков в рамках модуля */
  sort(id, data) {
    return APIService.post(`${NAMESPACE}/${id}/sort`, data);
  },
  /** Добавить модуль в курс */
  attach(id, data) {
    return APIService.post(`${NAMESPACE}/${id}/attach-course`, data);
  },
  /** Убрать модуль из курса */
  detach(id, data) {
    return APIService.post(`${NAMESPACE}/${id}/detach-course`, data);
  },
  /** Получить темы по модулю */
  courseUnits(moduleId, params) {
    return APIService.get(
      `${NAMESPACE}/${moduleId}/course-units`,
      { params, rOptions: { model: Unit, many: true } },
    );
  },
  /** Получить наборы по модулю */
  enrollments(id, params) {
    return APIService.get(
      `${NAMESPACE}/${id}/prior-records`,
      { params, rOptions: { many: true } },
    );
  },
  subscribersIndex(params) {
    return APIService.get(`${NAMESPACE}/requests`, { params, rOptions: { many: true } });
  },
  subscribersShow(id, params) {
    return APIService.get(`${NAMESPACE}/requests/${id}`, { params, rOptions: { single: true } });
  },
  subscribersUpdate(id, data) {
    return APIService.put(`${NAMESPACE}/requests/${id}`, data);
  },
};
